import React, { createContext, useContext, useState } from 'react';
import useWeb3 from '../../../../contexts/web3';
import { contractABI } from 'shared';

type AppliedCode = {
  code: string;
  discount: number;
};

interface IPromoContext {
  appliedCode: AppliedCode | undefined;
  apply: (code: string, callback: (result: AppliedCode | false) => any) => void;
  reset: () => void;
}

// @ts-ignore
const PromoContext = createContext<IPromoContext>();

interface Props {
  children: React.ReactNode;
}

export const PromoProvider = ({ children }: Props) => {
  const { connect } = useWeb3();
  const [appliedCode, setAppliedCode] = useState<AppliedCode | undefined>(
    undefined
  );

  const resetCode = () => {
    setAppliedCode(undefined);
  };

  const applyCode = (
    code: string,
    callback: (result: AppliedCode | false) => any
  ) => {
    if (code.length === 0) {
      return callback(false);
    }
    connect().then((data) => {
      const contract = new data.web3.eth.Contract(
        contractABI,
        process.env.REACT_APP_CONTRACT_ADDRESS
      );
      contract.methods
        .validateCode(code)
        .call()
        .then((result) => {
          const numeric = Number(result);
          if (!isNaN(numeric) && numeric > 0) {
            const toReturn = {
              code,
              discount: numeric
            };
            setAppliedCode(toReturn);
            callback(toReturn);
          } else {
            callback(false);
          }
        })
        .catch(() => callback(false));
    });
  };

  return (
    <PromoContext.Provider
      value={{ appliedCode, apply: applyCode, reset: resetCode }}
    >
      {children}
    </PromoContext.Provider>
  );
};

const usePromo = () => useContext(PromoContext);

export default usePromo;

export const calculateNewPrice = (price: number, discount): number => {
  if (discount < 0) return price;
  return (price * (100 - discount)) / 100;
};
